import UsersTable from '../components/UsersTable';

export default function UsersPage() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Users</h2>
      <p className="mt-1 text-sm text-gray-500">
        All users — DB record, Supabase auth, and Stripe customer.
      </p>
      <div className="mt-6 bg-white shadow rounded-lg overflow-hidden">
        <UsersTable />
      </div>
    </div>
  );
}
